module.exports = __webpack_public_path__ + "static/media/leave2.5149d0f7.svg";